<template>
  <div class="container presentation-container">
    <header style="background-color: #05689a;height: auto;width: 100%;padding: 25px;color: white">
      <div class="row">
        <div v-if="getApplicantType === 'RWS'"  class="col-sm-4">
          <img src="../../../public/assets/images/rws-white-logo.svg" alt="Logo" class="logo-rws">
        </div>
        <div v-else-if="getApplicantType === 'RISKPRO'"  class="col-sm-4">
          <img src="../../../public/assets/images/riskpro-logo.svg" alt="Logo" class="logo-rws">
        </div>
        <div v-else class="col-sm-4">
          <img src="../../../public/assets/images/orep-white-logo.png"  height="88" width="230" alt="Logo">
        </div>
      </div>
    </header>
    <div style="padding-left: 50px;padding-right: 50px;padding-top: 20px;">

      <div class="row">
        <div class="col-md-8">
          <p class="comic-font-bold" style="font-size: 30px; color: #05689a">
            <img src="">
            <strong>SECURE PAYMENT PROCESSING</strong>
          </p>
          <p class="comic-font-bold" style="font-size: 30px;">
            PREMIUM PROPOSAL
          </p>
        </div>
        <div v-if="getApplicantType === 'OREP'" class="col-md-auto text-center">
          <img src="../../../public/assets/images/call-1.png" alt="18 years">
        </div>
      </div>
      <hr class="new1" />

      <div class="row" style="margin-top: 30px">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-9 text-left">
          <div class="row">
            <div class="col-md-auto text-center">
              <p class="comic-font-bold" style="font-size: 20px;">
                PREMIUM PREPARED FOR: {{ quote.nameOfPrincipalHomeInspector }}
              </p>
            </div>
          </div>

          <hr class="new1">
        </div>

      </div>
      <div class="row" style="margin-top: 20px">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-auto text-left">
          <table class="">
            <tbody>
            <tr>
              <td>
                <p class="comic-font-bold" style="color: #05689a">
                  <strong>LIMITS OF COVERAGE:</strong>
                </p>
              </td>
              <td>
                <input type="text" :placeholder=coverages[quote.coverage].limitOfCoverage   style="width: 500px;" disabled>
              </td>
            </tr>
            <tr>
              <td style="margin-bottom: 3rem !important;">
                <strong>Retention:</strong>
              </td>
              <td>
                <input placeholder="$1,500" style="width: 500px;" disabled v-if="deductibleAmount">
                <input placeholder="$2,500" style="width: 500px;" disabled v-if="!deductibleAmount">
              </td>
            </tr>

            <tr>
              <td>
                <p class="comic-font-bold" style="color: #05689a">
                  <strong>E&O/GL Premium:</strong>
                </p>
              </td>
              <td>
                <input  v-if="quote.cyberCoverage"  type="text" :placeholder="coverages[quote.coverage].cyberPremium"   style="width: 500px;" disabled>
                <input v-else type="text" :placeholder="coverages[quote.coverage].premium"   style="width: 500px;" disabled>
              </td>
            </tr>

            <tr>
              <td>{{ quote.customer.state }} SL Tax:</td>
              <td>
                <input v-if="quote.cyberCoverage"  type="text" :placeholder="coverages[quote.coverage].cyberSurplusLineTax"   style="width: 500px;" disabled>
                <input v-else type="text" :placeholder="coverages[quote.coverage].surplusLineTax"   style="width: 500px;" disabled>
              </td>
            </tr>

            <tr>
              <td>{{ quote.customer.state }} SL Stamping Fee:</td>
              <td>
                <input v-if="quote.cyberCoverage"  type="text" :placeholder="coverages[quote.coverage].cyberStampingFee"   style="width: 500px;" disabled>
                <input v-else type="text" :placeholder="coverages[quote.coverage].stampingFee"   style="width: 500px;" disabled>
              </td>
            </tr>

            <tr>
              <td>Additional State Fee:</td>
              <td>
                <input v-if="quote.cyberCoverage"  type="text" :placeholder="coverages[quote.coverage].cyberExtraFee"   style="width: 500px;" disabled>
                <input v-else type="text" :placeholder="coverages[quote.coverage].extraFee"   style="width: 500px;" disabled>
              </td>
            </tr>

            <tr>
              <td>
                <strong>OREP Member Fee:</strong>
              </td>
              <td>
                <input :placeholder="coverages[quote.coverage].orepFee" style="width: 500px;" disabled>
              </td>
            </tr>
            <tr>
              <td>
                <p class="comic-font-bold" style="color: #05689a">
                  <strong>TOTAL:</strong>
                </p>
              </td>
              <td>
                <input  :placeholder="coverages[quote.coverage].cyberTotal" style="width: 500px;" disabled v-if="quote.cyberCoverage">
                <input  :placeholder="coverages[quote.coverage].total" style="width: 500px;" disabled v-else>
              </td>
            </tr>

            </tbody>
          </table>
        </div>

      </div>

      <div class="row" style="margin-top: 30px">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-9 text-left">
          <div class="row">
            <div class="col-md-auto text-left">
              <p>
                <strong>
                  <i>Please Note:</i>
                </strong>
                Your Insurance Policy is not in effect/bound until Payment or Down-Payment is received. <strong style="text-decoration: underline">To expedite coverage and avoid delays, please use one of these two links to make payment now.</strong>
              </p>
            </div>
          </div>
        </div>

      </div>

      <hr class="new1" />

      <div class="col text-center" style="margin-top: 50px;background-color:  #05689a">
        <p class="comic-font-bold" style="font-size: 25px; color: white">
          SELECT PAYMENT TYPE
        </p>
      </div>

      <div style="margin-top: 30px;margin-bottom: 50px;">
        <div>
          <div class="radio-button " style="text-align: center;align-content: center;justify-content: center">
            <div class="radio-button row" style="justify-content: center">
              <div>
                <input  type="radio" id="radio1" name="radios" :value=false v-model="state.paymentType" checked>
                <label for="radio1" style="margin-left: 40px;height: 275px;width: 250px" >
                  <i class="fa fa-bank fa-3x"></i>
                  <p class="comic-font-bold" style="margin-bottom: 1rem !important;">
                    <strong>Debit Card / ACH</strong>
                  </p>
                  <img
                    src="../../../public/assets/images/SSL_blue.png"
                    height="50"
                    width="100"
                    alt="SSL image"
                  >
                  <p class="text-left" style="margin-bottom: 1rem !important;" v-if="quote.cyberCoverage">
                    <strong>Amount: {{ coverages[quote.coverage].cyberTotal }}</strong>
                  </p>
                  <p class="text-left" style="margin-bottom: 1rem !important;" v-else>
                    <strong>Amount: {{ coverages[quote.coverage].total }}</strong>
                  </p>

                  <p class="text-left" style="margin-bottom: 1rem !important;">
                    <strong>Fee: $0.00</strong>
                  </p>
                  <p class="text-left" style="font-size: 20px;margin-bottom: 1rem !important;" v-if="quote.cyberCoverage">
                    <strong>Total: {{ coverages[quote.coverage].cyberTotal }}</strong>
                  </p>
                  <p class="text-left" style="font-size: 20px;margin-bottom: 1rem !important;" v-else>
                    <strong>Total: {{ coverages[quote.coverage].total }}</strong>
                  </p>
                  <p class="text-left comic-font-bold" style="font-size: 16px;color: #05689a;">
                    No Processing Fee
                  </p>
                  <p class="text-left" style="margin-bottom: 1rem !important;">
                    for Debit Card or ACH
                  </p>
                </label>
              </div>

              <div>
                <input type="radio" id="radio2" name="radios" :value=true v-model="state.paymentType">
                <label for="radio2" style="margin-left: 40px;height: 275px;width: 250px">
                  <i class="fa fa-credit-card fa-3x"></i>
                  <p class="comic-font-bold" style="margin-bottom: 1rem !important;">
                    <strong>Credit Card</strong>
                  </p>


                  <img
                    src="../../../public/assets/images/SSL_blue.png"
                    height="50"
                    width="100"
                    alt="background image"
                  >
                  <p class="text-left" style="margin-bottom: 1rem !important;" v-if="quote.cyberCoverage">
                    <strong>Amount: {{ coverages[quote.coverage].cyberTotal }}</strong>
                  </p>
                  <p class="text-left" style="margin-bottom: 1rem !important;" v-else>
                    <strong>Amount: {{ coverages[quote.coverage].total }}</strong>
                  </p>
                  <p class="text-left" style="margin-bottom: 1rem !important;" v-if="quote.cyberCoverage">
                    <strong>Fee: ${{ processing_fee(coverages[quote.coverage].cyberTotal)  }}</strong>
                  </p>
                  <p class="text-left" style="margin-bottom: 1rem !important;" v-else>
                    <strong>Fee: ${{  processing_fee(coverages[quote.coverage].total) }}</strong>
                  </p>
                  <p class="text-left" style="font-size: 20px;margin-bottom: 1rem !important;" v-if="quote.cyberCoverage">
                    <strong>Total: ${{ total_with_processing_fee(coverages[quote.coverage].cyberTotal)  }}</strong>
                  </p>
                  <p class="text-left" style="font-size: 20px;margin-bottom: 1rem !important;" v-else>
                    <strong>Total: ${{ total_with_processing_fee(coverages[quote.coverage].total) }}</strong>
                  </p>
                  <p v-if="getApplicantType=='RWS'" class="text-left comic-font-bold" style="font-size: 16px;color: #05689a;">
                    1.9% Processing Fee
                  </p>
                  <p v-else-if="getApplicantType=='RISKPRO'" class="text-left comic-font-bold" style="font-size: 16px;color: #05689a;">
                    1.9% Processing Fee
                  </p>
                  <p v-else class="text-left comic-font-bold" style="font-size: 16px;color: #05689a;">
                    0.9% Processing Fee
                  </p>
                  <p class="text-left" style="margin-bottom: 1rem !important;">
                    Lowest in the Industry!
                  </p>
                </label>
              </div>

            </div>
          </div>
        </div>
      </div>
      <hr class="new1" />
      <div v-show="state.paymentType === true" class="align-content-center text-center" style="margin-top: 30px;margin-bottom: 50px;">
        <div>
          <form action="https://www.asecurecart.net/server/cart.aspx/orepinsurance" target="_blank" method="POST" name="frm">
            <input name="TaxItem" type="hidden" value="n">
            <input name="AddEmail" type="hidden" value="inspectors@orep.org">
            <input v-if="getApplicantType == 'RWS'" name="AddEmail" type="hidden" value="info@rwsinsurance.com ">
            <input v-else-if="getApplicantType == 'RISKPRO'" name="AddEmail" type="hidden" value="RISKPRO@liabilityinsuranceapps.com">
            <input name="ID" type="hidden" value="Premium">
            <input name="ID" type="hidden" :value="quote.customer.state +' SL Tax'">
            <input name="ID" type="hidden" :value="quote.customer.state + ' SL Stamping Fee'">
            <input name="ID" type="hidden" value="OREP Fee">
            <input name="ID" type="hidden" value="Additional State Fee">
            <input name="ID" type="hidden" value="Processing Fee">
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].cyberPremium) v-if="quote.cyberCoverage" >
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].premium) v-if="!quote.cyberCoverage" >
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].cyberSurplusLineTax) v-if="quote.cyberCoverage" >
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].surplusLineTax) v-if="!quote.cyberCoverage" >
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].cyberStampingFee) v-if="quote.cyberCoverage" >
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].stampingFee) v-if="!quote.cyberCoverage" >
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].orepFee) >
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].cyberExtraFee) v-if="quote.cyberCoverage" >
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].extraFee) v-if="!quote.cyberCoverage" >
            <input name="Price" type="hidden" :value=processing_fee(coverages[quote.coverage].total) v-if="!quote.cyberCoverage" >
            <input name="Price" type="hidden" :value=processing_fee(coverages[quote.coverage].cyberTotal) v-if="quote.cyberCoverage" >
            <input name="Price" type="hidden" :value="1">
            <input name="Multi" type="hidden" value="Y">
            <input class="text-uppercase text-center comic-font-bold" style="margin-right: 65px; border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
                   name="Submit" type="submit" value="PROCEED TO PAYMENT">
            </form>
      </div>
        <a href="https://orep.org/google-reviews/" target="_blank">
        <img
          src="../../../public/assets/images/vcr_large.png"
          height="115"
          width="150"
          alt="SSL image"
        >
        </a>
        <img
          src="../../../public/assets/images/SecureSSLEncryption.png"
          height="150"
          width="150"
          alt="SSL image"
        >
        <div>

        </div>
      </div>
      <div v-show="state.paymentType === false" class="align-content-center text-center" style="margin-top: 30px;margin-bottom: 50px;">
        <div >
          <form action="https://www.asecurecart.net/server/cart.aspx/orepinsurance" target="_blank" method="POST" name="frm">
            <input name="TaxItem" type="hidden" value="n">
            <input name="AddEmail" type="hidden" value="inspectors@orep.org">
            <input v-if="getApplicantType == 'RWS'" name="AddEmail" type="hidden" value="info@rwsinsurance.com ">
            <input v-else-if="getApplicantType == 'RISKPRO'" name="AddEmail" type="hidden" value="RISKPRO@liabilityinsuranceapps.com">
            <input name="ID" type="hidden" value="Premium">
            <input name="ID" type="hidden" :value="quote.customer.state +' SL Tax'">
            <input name="ID" type="hidden" :value="quote.customer.state + ' SL Stamping Fee'">
            <input name="ID" type="hidden" value="OREP Fee">
            <input name="ID" type="hidden" value="Additional State Fee">
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].cyberPremium) v-if="quote.cyberCoverage" >
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].premium) v-if="!quote.cyberCoverage" >
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].cyberSurplusLineTax) v-if="quote.cyberCoverage" >
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].surplusLineTax) v-if="!quote.cyberCoverage" >
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].cyberStampingFee) v-if="quote.cyberCoverage" >
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].stampingFee) v-if="!quote.cyberCoverage" >
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].orepFee) >
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].cyberExtraFee) v-if="quote.cyberCoverage" >
            <input name="Price" type="hidden" :value=dollarSlicing(coverages[quote.coverage].extraFee) v-if="!quote.cyberCoverage" >
            <input name="Multi" type="hidden" value="Y">
            <input class="text-uppercase text-center comic-font-bold" style="margin-right: 65px; border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
                   name="Submit" type="submit" value="PROCEED TO PAYMENT">
          </form>
        </div>
        <a href="https://orep.org/google-reviews/" target="_blank">
        <img
          src="../../../public/assets/images/vcr_large.png"
          height="115"
          width="150"
          alt="SSL image"
        >
        </a>
        <img
          src="../../../public/assets/images/SecureSSLEncryption.png"
          height="150"
          width="150"
          alt="SSL image"
        >
        <div>

        </div>
      </div>
    </div>

    <footer v-if="getApplicantType == 'RWS'" style="background-color: #05689a;height: auto;width: 100%;padding: 40px;color: white">
      <div class="row">
        <div class="col-sm-4">
          <img src="../../../public/assets/images/rws-white-logo.svg" alt="Logo" class="logo-rws-footer">
        </div>
        <div class="col-sm-8">
          <p class="comic-font-bold" style="font-size: 18px;">
            RWS Insurance
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            695 Pro Med Lane,
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Carmel IN, 46032
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            866-530-0531
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            info@rwsinsurance.com
          </p>
        </div>
      </div>
    </footer>
    <footer v-else-if="getApplicantType == 'RISKPRO'" style="background-color: #05689a;height: auto;width: 100%;padding: 40px;color: white">
      <div class="row">
        <div class="col-sm-4">
          <img src="../../../public/assets/images/riskpro-logo.svg" alt="Logo" class="logo-rws-footer">
        </div>
        <div class="col-sm-8">
          <p class="comic-font-bold" style="font-size: 18px;">
            RISKPRO Insurance
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            901 Waterfall Way, Suite 407,
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Richardson, TX 75080
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            (972) 235-3030
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            RISKPRO@liabilityinsuranceapps.com
          </p>
        </div>
      </div>
    </footer>
    <footer v-else style="background-color: #05689a;height: auto;width: 100%;padding: 40px;color: white">
      <div class="row">
        <div class="col-sm-4">
          <img src="../../../public/assets/images/orep-white-logo.png" alt="Logo">
        </div>
        <div class="col-sm-8">
          <p class="comic-font-bold" style="font-size: 18px;">
            OREP Insurance Services, LLC California License #0K99465
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            6353 El Cajon Blvd, Suite 124-605
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            San Diego, CA 92115
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            (888) 347-5273
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            appraisers@OREP.org
          </p>
        </div>
      </div>
    </footer>
  </div>

</template>
<script>
import $ from "jquery";
import { STATES } from "../../utils/constants";
import moment from "moment";

export default {
  name: "home-inspector-payment",
  data() {
    return {
      loading: false
    };
  },
  computed: {
    quote() {
      return this.$store.state.homeInspector.quote;
    },
    coverages() {
      return this.$store.state.homeInspector.coverages;
    },
    state() {
      return this.$store.state.homeInspector;
    },
    // state() {
    //   return STATES[this.$store.state.homeInspector.quote.customer.state];
    // },

    isShowingRate() {
      return !(this.$store.getters['homeInspector/totalRevenueOfInspectionsInThisYear'] > 150000 ||
        this.$store.getters['homeInspector/totalRevenueOfInspectionsInNextYear'] > 150000 ||
        this.quote.licensedInWorkingStates === 'no' ||
        this.quote.haveYourExperiencedBankruptcyInLast7Years === 'true' ||
        this.quote.complianceInspections === 'true' ||
        this.quote.involvedInAuctionOfPersonalProperty === 'true' ||
        this.quote.performInspectionsOnOwnProperty === 'true' ||
        this.quote.providesRepairWorkOnInspectedProperty === 'true' ||
        this.quote.doYouUseIndependentContractors === 'true' ||
        Number(this.quote.homeInspectorsFullTime) + Number(this.quote.homeInspectorsPartTime) > 2 ||
        this.quote.knowledgeOfActEoPotentialClaimFuture === 'true' ||
        this.quote.hasBeenSubjectToEoClaimPast === 'true' ||
        this.quote.criticizedCensoredSuspendedRevoked === 'true' ||
        this.quote.insuranceDeniedCancelledNonrenewedInsurance === 'true' ||
        this.quote.applicantExclusiveToAnyCompany === 'true' ||
        this.quote.isThereAMethodToAuthenticatePhotoDatetime === 'false' ||
        this.quote.customer.state === 'HI' ||
        this.quote.customer.state === 'AK'
        || this.quote.customer.state === 'KY');
    },
    isShowingUnderneathText() {
      return this.quote.singleClientProvidesMt25PercentRevenue === 'true' ||
        this.quote.applicantExclusiveToAnyCompany === 'true' ||
        this.quote.providesOtherServices === 'true' ||
        this.quote.applicantOrAssociateProvidesOtherServices === 'true' ||
        this.quote.enteredLimitedLiabilityContract === 'true' ||
        this.quote.applicantOrAssociateHasAnyOtherProfessionalLicense === 'true' ||
        this.quote.isPreInspectionAgreementAlwaysSigned === 'false' ||
        this.quote.applicantTakesDigitalPhotosOfInspections === 'false' ||
        this.quote.isThereAMethodToAuthenticatePhotoDatetime === 'false' ||
        this.quote.applicantTakesContinuingTrainingYearly === 'false' ||
        this.quote.averageOfMoreThan3InspectionsPerDayPerInspector === 'true';
    },
    deductibleAmount() {

      return ((this.quote.homeInspectingExperience === '3-to-7' ||
        this.quote.homeInspectingExperience === '3-to-7' ) &&
        this.quote.knowledgeOfActEoPotentialClaimFuture === 'false' &&
        this.quote.hasBeenSubjectToEoClaimPast === 'false' &&
        this.quote.criticizedCensoredSuspendedRevoked === 'false' &&
        this.quote.insuranceDeniedCancelledNonrenewedInsurance === 'false' &&
        this.quote.preInspectionAgreementHasLimitationOfLiabilityClause === 'true' &&
        this.$store.getters['homeInspector/totalRevenueOfInspectionsInThisYear'] <= 150000 &&
        Number(this.quote.homeInspectorsFullTime) + Number(this.quote.homeInspectorsPartTime) < 3);
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/home-inspector-ibd/' || first === '/portal/home-inspector-IBD/'|| this.quote.customer.partnerName === 'IBD'){
        return 'IBD';
      }else if (first === '/portal/home-inspector-rws/' || first === '/portal/home-inspector-rws/'|| this.quote.customer.partnerName === 'RWS'){
        return 'RWS';
      }else if (first === '/portal/home-inspector-spmga/' || first === '/portal/home-inspector-spmga/'|| this.quote.customer.partnerName === 'SPMGA'){
        return 'SPMGA';
      }
      else if (first === '/riskpro/home-inspector/' || first === '/RISKPRO/home-inspector/' || this.quote.customer.partnerName === 'RISKPRO'){
        return 'RISKPRO';
      }
      else {
        return 'OREP';
      }
    },
  },
  methods: {
    dollarSlicing(sclicingValue) {
      return sclicingValue.slice(1);
    },
    formattedCurrentDate() {
      return moment.utc(this.quote.applicantPrincipleEsignatureDatetime).format('MM/DD/YYYY');
    },
    total(coverages) {
      if (this.quote.cyberCoverage){
        return parseFloat((coverages[this.quote.coverage].cyberPremium).slice(1).replace(',','')) + parseFloat((coverages[this.quote.coverage].cyberSurplusLineTax).slice(1)) + parseFloat((coverages[this.quote.coverage].cyberStampingFee).slice(1)) + parseFloat((coverages[this.quote.coverage].cyberExtraFee).slice(1));
      }
      else {
        return parseFloat((coverages[this.quote.coverage].premium).slice(1).replace(',','')) + parseFloat((coverages[this.quote.coverage].surplusLineTax).slice(1)) + parseFloat((coverages[this.quote.coverage].stampingFee).slice(1)) + parseFloat((coverages[this.quote.coverage].extraFee).slice(1));

      }
    },
    processing_fee(total) {
      if ( this.getApplicantType == 'RWS'){
        return (parseFloat((total).slice(1).replace(',','')) * 0.019).toFixed(2);
      }
      else if ( this.getApplicantType == 'RISKPRO'){
        return (parseFloat((total).slice(1).replace(',','')) * 0.019).toFixed(2);
      }
      else{
        return (parseFloat((total).slice(1).replace(',','')) * 0.009).toFixed(2);
      }
    },
    total_with_processing_fee(total) {
      if ( this.getApplicantType == 'RWS') {
        return ((parseFloat((total).slice(1).replace(',', ''))) + (parseFloat((total).slice(1).replace(',', '')) * 0.019)).toFixed(2);
      }
      else if ( this.getApplicantType == 'RISKPRO') {
        return ((parseFloat((total).slice(1).replace(',', ''))) + (parseFloat((total).slice(1).replace(',', '')) * 0.019)).toFixed(2);
      }
      else{
        return ((parseFloat((total).slice(1).replace(',', ''))) + (parseFloat((total).slice(1).replace(',', '')) * 0.009)).toFixed(2);
      }
    },
  },
  mounted() {
    $('html, body').animate({
      scrollTop: $('.presentation-container').offset().top
    }, 500);
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Open+Sans');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
.radio-button {
  margin: 15px;
}
.radio-button input[type="radio"] {
  opacity: 0;
  position: fixed;
  width: 0;
}
.radio-button label {
  display: inline-block;
  background-color: #ffffff;
  padding: 10px 40px;
  font-family: sans-serif, Arial;
  font-size: 16px;
  border: 1px solid #05689a;
  border-radius: 4px;
}
.radio-button label:hover {
  background-color: #05689a;
}

.radio-button input[type="radio"]:focus + label {
  border: 2px dashed #f1f1f1;
}
.radio-button input[type="radio"]:checked + label {
  background-color: #f1f1f1;
  border-color: #05689a;
}

.container {
  background-color: white !important;
  padding-right: 0px;
  padding-left: 0px;
}
.img-call {
  height: 170px;
  max-height: 170px;
}
p {
  margin: 5px 0;
}
.strong {
  font-weight: bold !important;
}
li{
  margin: 12px 0;
}
table td {
  padding: 0 5px 15px !important;
}
table > tbody > tr > td:first-child {
  width: 35%
}
table > tbody > tr > td:last-child {
  width: 65%
}


::placeholder {
  color: black;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: black;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: black;
}
.table-bordered td {
  vertical-align: top;
  border-right: 2px solid #dee2e6;
  border-left-width: 0;
  border-bottom-width: 0;
  border-top-width: 0;
}
* {
  box-sizing: border-box;
}

/* Create three unequal columns that floats next to each other */
.column {
  float: center;
  padding: 10px;
  height: 300px; /* Should be removed. Only for demonstration */
}

.left {
  width: 25%;
}
.right {
  width: 5%;
}

.middle {
  width: 63%;
}

.comic-font{
  font-family: 'Open Sans';
}
.comic-font-bold{
  font-family: 'Open Sans';
  font-weight: bold;
}
hr.new1 {
  border-top: 1px solid grey;
}
.no-gutter > [class*='col-'] {
  padding-right:0;
  padding-left:0;
}
</style>
